import React, { createContext, useReducer, useMemo } from "react";
import _ from 'underscore';

let TareasContext = createContext();

let initialState = {
  listaTareas: {},
  tareasCorriendo: [],
  ultimoCambio: []
};

let reducer = (state, action) => {
  switch (action.type) {
    case "reset": {
      return initialState;
    }
    case "setListaTareas": {
      return { ...state, listaTareas: action.data };
    }
    case "setTareasCorriendo":
      return { ...state, tareasCorriendo: action.data };
    case "cambiaTarea": {
      let tareasCorriendo = [...state.tareasCorriendo];
      let datosLista = state.listaTareas.datos ? [...state.listaTareas.datos] : [];

      action.datos.forEach(i => {
        if (i.estado === "Creada") {
          if (!tareasCorriendo.includes(i.id)) tareasCorriendo.push(i.id);
        } else if (i.estado === "Finalizada" || i.estado === "Error") {
          tareasCorriendo = tareasCorriendo.filter(it => it !== i.id);
        }

        if (i.estado !== "Creada") {
          if (i.estado !== "Finalizada" && i.estado !== "Error" && !tareasCorriendo.includes(i.id)) {
            tareasCorriendo.push(i.id);
          }
          const index = datosLista.findIndex(it => it.id_tarea === i.id);
          if (index >= 0) {
            datosLista[index] = {
              ...datosLista[index],
              estado: i.estado,
              fecha_ultimo_cambio: i.fecha
            };
          }
        }
      });

      return {
        ...state,
        tareasCorriendo,
        listaTareas: state.listaTareas.datos ? { ...state.listaTareas, datos: datosLista } : state.listaTareas,
        ultimoCambio: action.datos
      };
    }
    default:
      return state;
  }
};

function TareasProvider(props) {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <TareasContext.Provider value={value}>{props.children}</TareasContext.Provider>
  );
}

let TareasConsumer = TareasContext.Consumer;

export { TareasContext, TareasProvider, TareasConsumer };